let text =
{
	ABOUT:
	`I'm a Full Stack Developer from San Francisco who enjoys building all kinds of applications including
	rich, interactive web apps, native apps, and games.

	I've worked with many different coding languages, most recently with a heavy focus on Web Development.
	I use <strong>NodeJS</strong> or <strong>PHP</strong> for the back-end of my websites and have a mastery of 
	<strong> SQL, HTML5, CSS, and Javascript</strong>.

	I also write <strong>Python, C, Java, LUA, and Pawn</strong> (C-based scripting language).

	I have experience with all stages of product creation including <strong>planning,
	prototyping, testing, and deploying</strong> and can handle all of the technical parts of your project.`,

	/*ABOUT_CURRENT:
	`I currently study at the <strong>University of Washington</strong> and am pursuing a degree in Computer Science. There I'm also a part of the
	<strong>Advanced Robotics</strong> team which competes on an international stage during the summer and battles other university's robots. My team
	works on creating a simulation of the game in <strong>Unity</strong> and I focus on <strong>networking</strong> which allows multiple people
	to play the simulation simultaneously.`,*/

	SKILL_WEBDEV:
	`Mastery of the LAMP stack and popular libraries such as React and jQuery and using socket.io to create user-to-user interactions.`,

	SKILL_CSHARP:
	`Creating Windows Forms and Console Applications, overriding system devices, and designing a custom network protocol.`,

	SKILL_GAMEDEV:
	`Experience using Unity to create games from scratch and writing level scripts in LUA and Javascript for existing games.`,

	SKILL_BUSSOL:
	`Increasing website views, developing social media dashboards to boost followers, and search engine optimization.`,

	PORTFOLIO:
	`Below is a collection of both professional and personal projects that I've worked on. Hover over them to get links to either the case study,
	website, and/or the GitHub repository. <strong>A red bar under the project means it has a case study.</strong>`,

	CONTACT:
	`If you're looking for someone to help make your business more successful, feel free to fill out the form below or
	email me at <strong>andrew.guterman1@gmail.com</strong>.`,
};

module.exports = text;


// WEBPACK FOOTER //
// ./src/js/text.js